export default [
  {
    path: '/operations/roles',
    name: 'operations-roles',
    component: () => import('@/views/Operations/operationsRoles.vue'),
  },
  {
    path: '/operations/create-role',
    name: 'create-role',
    component: () => import('@/views/Operations/CreateRole.vue'),
  },
  {
    path: '/operations/roles/preview/:id',
    name: 'operations-roles-preview',
    component: () => import('@/views/Operations/operationsRolesPreview.vue'),
  },
  {
    path: '/operations/permissions',
    name: 'operations-permissions',
    component: () => import('@/views/Operations/operationsPermissions.vue'),
  },
  {
    path: '/operations/page-permissions',
    name: 'page-permissions',
    component: () => import('@/views/Users/PagePermissions.vue'),
  },

  {
    path: '/operations/exchange-rate',
    name: 'exchange-rate',
    component: () => import('@/views/Operations/ExchangeRate.vue'),
  },
  {
    path: '/operations/page-permissions/add',
    name: 'add-page-permissions',
    component: () => import('@/views/Users/AddPagePermissions.vue'),
  },
  {
    path: "/reports",
    name: "reports",
    component: () => import("@/views/Users/reports.vue"),
  },
];

